// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// ** Icons Imports
import MenuIcon from 'mdi-material-ui/Menu'

// ** Components
import Autocomplete from 'src/layouts/components/Autocomplete'
import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import { Typography } from '@mui/material'
import { useAuth } from 'src/hooks/useAuth'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const AppBarContent = props => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props
  const { user } = useAuth()
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <MenuIcon />
          </IconButton>
        ) : (
          <Box sx={{ display: 'flex', gap: '10px' }}>
            <Typography sx={{ fontSize: '26px', lineHeight: ' 39px', color: '#000000', fontWeight: 700 }}>
              {t('DashboardData.Hello')}
              {''},
            </Typography>
            <Typography sx={{ fontSize: '26px', lineHeight: ' 39px', color: '#FC5722', fontWeight: 700 }}>
              {[user?.firstName, user?.lastName].filter(Boolean).join(' ')}
            </Typography>
          </Box>
        )}
        {/* <Autocomplete hidden={hidden} settings={settings} /> */}
      </Box>
      <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <LanguageDropdown settings={settings} saveSettings={saveSettings} />
        {/* <ModeToggler settings={settings} saveSettings={saveSettings} /> */}
        <NotificationDropdown settings={settings} />
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  )
}

export default AppBarContent
